import { MemberAnketaProgression } from './MemberAnketaProgression';

export default MemberAnketaProgression;